import * as Yup from 'yup';

const schema = Yup.object({
  size: Yup.mixed()
    .nullable()
    .label('Rengaskoko'),
  product_id: Yup.number()
    .nullable()
    .label('Rengastuote'),
  owner_id: Yup.number()
    .nullable()
    .label('Omistaja'),
  customer_id: Yup.number()
    .nullable()
    .label('Asiakas'),
  over_target: Yup.bool()
    .nullable()
    .default(true),
  reaching_target: Yup.bool()
    .nullable()
    .default(true),
  below_target: Yup.bool()
    .nullable()
    .default(true),
  location_id: Yup.number()
    .nullable()
    .label('Paikka'),
  track_depth: Yup.array(Yup.number()).nullable(),
  range: Yup.object({
    start_at: Yup.object(),
    end_at: Yup.object()
  }).nullable()
});

export const initialValues = {
  size: null,
  product_id: null,
  customer_id: null,
  location_id: null,
  track_depth: [0, 20],
  range: {}
};

export default schema;
export type Schema = ReturnType<typeof schema.cast>;
